import { render } from "./ApiV2.vue?vue&type=template&id=6774e99e&scoped=true"
import script from "./ApiV2.vue?vue&type=script&lang=js"
export * from "./ApiV2.vue?vue&type=script&lang=js"

import "./ApiV2.vue?vue&type=style&index=0&id=6774e99e&lang=css"
import "./ApiV2.vue?vue&type=style&index=1&id=6774e99e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6774e99e"]])

export default __exports__